import { Typography, capitalize } from "@mui/material";
import { ReactElement } from "react";
import { useTranslation } from "react-i18next";

import { TextInput } from "common/components/form/TextInput";
import { AuthFormProps } from "models/Auth";
import { globalStyles } from "ui/globalStyles";

import * as Styled from "../styles/Auth.styled";

import { ActionButtons } from "./ActionButtons";


export function PasswordForgottenForm({ isError, isLoading, isSuccess, onClick }: AuthFormProps): ReactElement {
    const { t } = useTranslation();
    return (
        <>
            <Styled.AuthContent>
                <Typography sx={{ fontWeight: "bold", mt: 2.5 }} variant="h3">
                    {capitalize(t("modules.auth.passwordForgottenInfo"))}
                </Typography>
                <TextInput
                    field="email"
                    helperText={capitalize(t("modules.auth.provideEmail"))}
                    inputProps={globalStyles.authTextInputProps}
                    inputlabelstyles={globalStyles.authTextInputLabelStyles}
                    label={t("modules.auth.email")}
                    variant="standard" />
            </Styled.AuthContent>

            {isSuccess && <Typography sx={{ color: "success.main" }}>
                {capitalize(t("modules.auth.resetPasswordRequestSuccess"))}
            </Typography>}
            {isError && <Typography sx={{ color: "error.main" }}>
                {capitalize(t("modules.auth.resetPasswordRequestFail"))}
            </Typography>}

            <ActionButtons
                buttons={[
                    { onClick, text: capitalize(t("common.back")), type: "button" },
                    { isLoading, sx: globalStyles.buttonBlack, text: capitalize(t("common.send")), type: "submit" },
                ]}
            />
        </>
    );
}
